import React from 'react';
import PropTypes from "prop-types";

import styled from 'styled-components';

import { Client } from "../../client";

const Circle = styled.div`
    position: absolute;
    z-index: 99;
    left: -25%;
    top: 0%;
    box-shadow: 16px 16px 64px rgb(0 0 0 / 5%);
    width: 230px;
    height: 230px;
    border-radius: 50%;
    border:2px solid white;
    background: rgb(255, 255, 255);
    text-align: center;
    vertical-align: middle;
    line-height: 230px;
    font-size: ${props => props.fontFamily === 'MiniCorsiva' ? '20px' : '32px'};
    letter-spacing: ${props => props.fontFamily === 'Arial' ? '7px' : '4px'};
    text-indent: ${props => props.fontFamily === 'Arial' ? '7px' : '4px'};
    font-family: ${props => props.fontFamily};
    color: ${props => props.color};
    background-image: url(${props => props.backgroundImage});
    background-size: cover;
    background-position-x: -35px;

    @media screen and (max-width: 768px){
        left: 5px;
        right: 5px;
        top: 20%;
        margin: auto;
        height: ${props => props.size == 'small' ? '130px' : '170px'};
        line-height: ${props => props.size == 'small' ? '130px' : '170px'};
        width: ${props => props.size == 'small' ? '130px' : '170px'};
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
        border-radius: 50%;
        border: 3px solid white;
        font-size: ${props => 
            props.fontFamily === 'MiniCorsiva' ? '14px' : 
            props.size == 'small' ? '18px' : '20px'};
        letter-spacing: ${props => 
            props.fontFamily === 'Arial' ? '4px' : 
            props.size == 'small' ? '1px' : '4px'};
        text-indent: ${props => 
            props.fontFamily === 'Arial' ? '2px' : 
            props.size == 'small' ? '0px' : '4px'};
    }
`;

const FontSelector = ({ text, font, color, fabricArticle, size }) => {console.log(font);
    if (fabricArticle.includes('Coupon') || fabricArticle.includes('Custom')) { 
        var imgBack = Client.getRemarkImageUrl('RC-White');
    } else {
        var imgBack = Client.getRemarkImageUrl(fabricArticle);
    }
    console.log(imgBack);
    return (
        <Circle
            fontFamily={font}
            color={color}
            backgroundImage = {imgBack}
            size={size}
        >
            {text}
        </Circle>
    );
}

FontSelector.propTypes = {
    text: PropTypes.string.isRequired,
    font: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    fabricArticle: PropTypes.string.isRequired,
    size: PropTypes.string,
}

export default FontSelector;
